import { onAuthStateChanged } from "firebase/auth";
import React, { useEffect, useState } from "react";
import { auth, db } from "../firebase-config";
import { useLocation, useNavigate } from "react-router-dom";
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, orderBy, query, runTransaction, setDoc, where } from "firebase/firestore";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../redux/userReducer'
import { checkEmailInValid, getFirebaseDocs, getUrlParams, randomString } from '../common'
import Header from '../components/Header'
import Input from "../components/Input";
import MyDropzone from "../components/MyDropzone";
import { addDays, format, getWeek, isAfter, startOfWeek, subDays } from "date-fns";
import Tabs from "../components/Tabs";
import Checkbox from "../components/Checkbox";
import ModalComp from '../components/Modal';
import axios from 'axios'

const Users = () => {

    const [returnedUsers, setReturnedUsers] = useState([])
    const [search, setSearch] = useState('')
    const [statsUser, setStatsUser] = useState([])
    const [coachTabStatsUser, setCoachTabStatsUser] = useState([])
    const [coachBrainWatchedStatsUser, setCoachBrainWatchedStatsUser] = useState([])
    const [coachTestingCompletedStatsUser, setCoachTestingCompletedStatsUser] = useState([])
    const [submittedStatsUser, setSubmittedStatsUser] = useState([])
    const [completedStatsUser, setCompletedStatsUser] = useState([])
    const [selectedStatsUser, setSelectedStatsUser] = useState(null)
    const [groups, setGroups] = useState([])

    const [activeTab, setActiveTab] = useState('All')
    const [editId, setEditId] = useState('')
    const [groupName, setGroupName] = useState('')
    const [groupIcon, setGroupIcon] = useState('')
    const [members, setMembers] = useState([])
    const [isAdding, setIsAdding] = useState('')
    const [showDeletePopup, setShowDeletePopup] = useState(false)

    const [notificationTitle, setNotificationTitle] = useState('')
    const [notificationBody, setNotificationBody] = useState('')

    const [loginMetadata, setLoginMetadata] = useState({})
    const [loadingLoginMetadata, setLoadingLoginMetadata] = useState(false)

    const [scheduledNotifications, setScheduledNotifications] = useState([])
    const [scheduledNotificationsTab, setScheduledNotificationsTab] = useState('Upcoming')
    const [showScheduleNotification, setShowScheduleNotification] = useState(false)
    const [editingScheduledNotificationId, setEditingScheduledNotificationId] = useState('')
    const [scheduleAudience, setScheduleAudience] = useState('parent')
    const [scheduleTitle, setScheduleTitle] = useState('')
    const [scheduleBody, setScheduleBody] = useState('')
    const [scheduleAt, setScheduleAt] = useState('')
    const [savingScheduledNotification, setSavingScheduledNotification] = useState(false)

    const [showNotifyCoaches, setShowNotifyCoaches] = useState(false)
    const [showNotifyParents, setShowNotifyParents] = useState(false)
    const [showNotifyCenters, setShowNotifyCenters] = useState(false)
    const [showAddUser, setShowAddUser] = useState(false)
    const [addFirstName, setAddFirstName] = useState('')
    const [addLastName, setAddLastName] = useState('')
    const [addEmail, setAddEmail] = useState('')
    const [addPassword, setAddPassword] = useState(randomString(10))
    const [addChildName, setAddChildName] = useState('')
    const [addRole, setAddRole] = useState('staff')
    const [addUserLoading, setAddUserLoading] = useState(false)
    const [editingUserId, setEditingUserId] = useState('')
    const [editingRole, setEditingRole] = useState('staff')
    const [deletingUserId, setDeletingUserId] = useState('')
    const [deleteUserLoading, setDeleteUserLoading] = useState(false)
    const [influencers, setInfluencers] = useState([])
    const [influencerName, setInfluencerName] = useState('')
    const [influencerEmail, setInfluencerEmail] = useState('')
    const [creatingInfluencer, setCreatingInfluencer] = useState(false)
    const [togglingInfluencerCode, setTogglingInfluencerCode] = useState('')
    const [showAddInfluencer, setShowAddInfluencer] = useState(false)

    const [page, setPage] = useState('Users')
    const [loading, setLoading] = useState(false)
    // const [mode, setMode] = useState(modes[0])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()
    // const [coachCategories, setCoachCategories] = useState([])

    const [currentDate, setCurrentDate] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
    const weekOfYear = getWeek(currentDate)

    const [schedules, setSchedules] = useState([])
    const [bookings, setBookings] = useState([])
    const [allBookings, setAllBookings] = useState([])
    const [allHolidayBookings, setAllHolidayBookings] = useState([])
    const [bookingInterests, setBookingInterests] = useState([])

    const [showBookingDetails, setShowBookingDetails] = useState(false)

    const userInfo = useSelector(state => state.user.user)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                const uid = user.uid
                getUserInfo(uid)
            } else {
                // User is signed out
                navigate('/login')
                // ...
            }
        })
        return () => unsubscribe()
    }, [])

    useEffect(() => {
        if (page === 'Groups') {
            fetchUserGroups()
        } else if (page === 'Bookings') {
            fetchBookings()
            fetchAllBookings()
            fetchBookingInterests()
            getSchedule()
        } else if (page === 'Holiday Bookings') {
            fetchAllHolidayBookings()
        } else if (page === 'Scheduled Notifications') {
            fetchScheduledNotifications()
        }
    }, [page])

    useEffect(() => {
        if (page === 'Bookings') {
            fetchBookings()
        }
    }, [currentDate])

    useEffect(() => {
        if (userInfo && userInfo.role === 'admin') {
            const urlParams = getUrlParams()
            if (urlParams && urlParams.id) {
                fetchStats(urlParams && urlParams.id)
            } else {
                if (returnedUsers.length === 0) {
                    console.log('fetching users')
                    fetchUsers()
                }
                fetchInfluencers()
            }
        }
    }, [userInfo, location])


    const fetchBookings = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'bookings'), where('fromWeek', '<=', weekOfYear), where('tillWeek', '>=', weekOfYear), where('year', '==', new Date().getFullYear()))))
        setBookings(docs)
    }

    const fetchAllBookings = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'bookings'), orderBy('created', 'desc'))))
        setAllBookings(docs)
    }

    const fetchAllHolidayBookings = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'bookings-holidays'), orderBy('created', 'desc'))))
        setAllHolidayBookings(docs)
    }

    const fetchBookingInterests = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'express-interest-booking'), orderBy('currentDate', 'desc'))))
        setBookingInterests(docs)
    }

    const fetchUserGroups = async () => {
        const groupsDb = await getFirebaseDocs(await getDocs(query(collection(db, `chat-groups`))))
        setGroups(groupsDb)
    }


    const getSchedule = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'booking-schedule'))))
        // console.log('schedule', docs)
        setSchedules(docs)
    }

    const fetchStats = async (id) => {


        // pullAllActivitiesInfo()

        setStatsUser([])
        setCoachTabStatsUser([])
        setCoachBrainWatchedStatsUser([])
        setCoachTestingCompletedStatsUser([])
        setCompletedStatsUser([])
        setSubmittedStatsUser([])
        setSelectedStatsUser(null)
        setLoading(true)

        const selectedUserDoc = await getDoc(doc(db, 'users', id))
        const selectedUserData = selectedUserDoc.data() || null

        if (selectedUserData) {
            setSelectedStatsUser({ ...selectedUserData, id })
        } else {
            const allUsers = await getFirebaseDocs(await getDocs(query(collection(db, 'users'))))
            const matchingParent = allUsers.find(user => Array.isArray(user.children) && user.children.find(child => child.id === id))
            const matchingChild = matchingParent && Array.isArray(matchingParent.children)
                ? matchingParent.children.find(child => child.id === id)
                : null

            setSelectedStatsUser(matchingParent ? {
                id,
                role: 'child',
                firstName: matchingParent.firstName || '',
                lastName: matchingParent.lastName || '',
                email: matchingParent.email || '',
                parentName: `${matchingParent.firstName || ''} ${matchingParent.lastName || ''}`.trim(),
                childName: matchingChild && matchingChild.name ? matchingChild.name : '',
            } : null)
        }

        const statsInfo = [], completedInfo = [], submittedInfo = [], invalidActivityIds = []
        const watchedEntertainmentVideos = await getFirebaseDocs(await getDocs(query(collection(db, `watched-entertainment-video`), where('userId', '==', id))))
        const watchedTestingVideos = await getFirebaseDocs(await getDocs(query(collection(db, `watched-testing-video`), where('userId', '==', id))))
        const watchedLearnVideos = await getFirebaseDocs(await getDocs(query(collection(db, `watched-video`), where('userId', '==', id))))

        for (let row of watchedLearnVideos) {
            const info = await (await getDoc(doc(db, 'learn-activities', row.activityId))).data()
            statsInfo.push({ ...row, ...info, filter: 'learn' })
        }
        for (let row of watchedTestingVideos) {
            const info = await (await getDoc(doc(db, 'testing-activities', row.activityId))).data()
            statsInfo.push({ ...row, ...info, filter: 'testing' })
        }
        for (let row of watchedEntertainmentVideos) {
            const info = await (await getDoc(doc(db, 'entertainment-activities', row.activityId))).data()
            statsInfo.push({ ...row, ...info, filter: 'entertainment' })
        }

        const submissionsOfActivities = await getFirebaseDocs(await getDocs(query(collection(db, `activity-submissions`), where('userId', '==', id))))
        const completionsOfActivities = await getFirebaseDocs(await getDocs(query(collection(db, `activity-completed`), where('userId', '==', id))))
        // console.log('submissionsOfActivities', submissionsOfActivities)
        for (let row of submissionsOfActivities) {
            let foundActivityInfo = false
            const previousActivityIds = submittedInfo.map(r => r.activityId)
            // console.log('activityId', row.activityId, previousActivityIds, !previousActivityIds.find(r => r === row.activityId))
            if (!previousActivityIds.find(r => r === row.activityId) && !invalidActivityIds.includes(row.activityId)) {
                const learnInfo = await (await getDoc(doc(db, 'learn-activities', row.activityId))).data()
                if (learnInfo) {
                    foundActivityInfo = true
                    submittedInfo.push({ ...row, ...learnInfo, filter: 'learn' })
                }
                const testInfo = await (await getDoc(doc(db, 'testing-activities', row.activityId))).data()
                if (testInfo) {
                    foundActivityInfo = true
                    submittedInfo.push({ ...row, ...testInfo, filter: 'testing' })
                }
                const entertainmentInfo = await (await getDoc(doc(db, 'entertainment-activities', row.activityId))).data()
                if (entertainmentInfo) {
                    foundActivityInfo = true
                    submittedInfo.push({ ...row, ...entertainmentInfo, filter: 'entertainment' })
                }
                if (!foundActivityInfo) {
                    invalidActivityIds.push(row.activityId)
                }
            }
        }

        const activitiesOfCompletion = completionsOfActivities.map(r => r.activities).flat().map(r => ({ activityId: r }))

        for (let row of activitiesOfCompletion) {
            let foundActivityInfo = false
            const previousActivityIds = completedInfo.map(r => r.activityId)
            // console.log('activityId', row.activityId, previousActivityIds, !previousActivityIds.find(r => r === row.activityId))
            if (!previousActivityIds.find(r => r === row.activityId) && !invalidActivityIds.includes(row.activityId)) {
                const learnInfo = await (await getDoc(doc(db, 'learn-activities', row.activityId))).data()
                if (learnInfo) {
                    foundActivityInfo = true
                    completedInfo.push({ ...row, ...learnInfo, filter: 'learn' })
                }
                const testInfo = await (await getDoc(doc(db, 'testing-activities', row.activityId))).data()
                if (testInfo) {
                    foundActivityInfo = true
                    completedInfo.push({ ...row, ...testInfo, filter: 'testing' })
                }
                const entertainmentInfo = await (await getDoc(doc(db, 'entertainment-activities', row.activityId))).data()
                if (entertainmentInfo) {
                    foundActivityInfo = true
                    completedInfo.push({ ...row, ...entertainmentInfo, filter: 'entertainment' })
                }
                if (!foundActivityInfo) {
                    invalidActivityIds.push(row.activityId)
                }
            }
        }

        const coachViewedTabs = await getFirebaseDocs(await getDocs(query(collection(db, `coach-viewed-activity-tabs`), where('userId', '==', id))))
        const coachWatchedBrainVideos = await getFirebaseDocs(await getDocs(query(collection(db, `coach-watched-brain-video`), where('coachId', '==', id))))
        const coachTestingCompletedDocs = await getFirebaseDocs(await getDocs(query(collection(db, `coach-testing-completed`), where('userId', '==', id))))

        const coachViewedTabInfo = await Promise.all(coachViewedTabs.map(async (row) => {
            let categoryName = row.categoryName || ''
            let subCategoryName = row.subCategoryName || ''

            if (!categoryName && row.categoryId) {
                const categoryDoc = await getDoc(doc(db, 'learn-categories', row.categoryId))
                categoryName = categoryDoc.data()?.name || ''
            }

            if (!subCategoryName && row.subCategoryId) {
                const subCategoryDoc = await getDoc(doc(db, 'learn-subcategories', row.subCategoryId))
                subCategoryName = subCategoryDoc.data()?.name || ''
            }

            return {
                ...row,
                categoryName,
                subCategoryName,
            }
        }))

        const coachWatchedBrainInfo = await Promise.all(coachWatchedBrainVideos.map(async (row) => {
            let activityName = row.activityName || ''
            let categoryName = ''

            if (!activityName && row.activityId) {
                const activityDoc = await getDoc(doc(db, 'brain-activities', row.activityId))
                const activityData = activityDoc.data()
                activityName = activityData?.name || ''
            }

            if (row.categoryId) {
                const categoryDoc = await getDoc(doc(db, 'brain-categories', row.categoryId))
                categoryName = categoryDoc.data()?.name || ''
            }

            return {
                ...row,
                activityName,
                categoryName,
            }
        }))

        const coachTestingCompletedInfo = coachTestingCompletedDocs.length === 0 ? [] : await Promise.all(
            (() => {
                const payload = coachTestingCompletedDocs[0] || {}
                const legacyIds = Array.isArray(payload.activities) ? payload.activities : []
                const datedEntries = payload.completedActivityDates && typeof payload.completedActivityDates === 'object'
                    ? Object.entries(payload.completedActivityDates)
                    : []
                const dedupedActivityIds = [...new Set([...legacyIds, ...datedEntries.map(([activityId]) => activityId).filter(Boolean)])]

                return dedupedActivityIds.map(async (activityId) => {
                    const activityDoc = await getDoc(doc(db, 'testing-coach-activities', activityId))
                    const activityData = activityDoc.data() || {}
                    return {
                        id: activityId,
                        activityId,
                        name: activityData.name || activityId,
                        completedAt: payload.completedActivityDates && typeof payload.completedActivityDates === 'object'
                            ? (payload.completedActivityDates[activityId] || payload.updatedAt || '')
                            : (payload.updatedAt || '')
                    }
                })
            })()
        )

        setSubmittedStatsUser(submittedInfo)
        setCompletedStatsUser(completedInfo)
        setCoachTabStatsUser(coachViewedTabInfo.sort((a, b) => isAfter(new Date(a.date), new Date(b.date)) ? -1 : 1))
        setCoachBrainWatchedStatsUser(coachWatchedBrainInfo.sort((a, b) => isAfter(new Date(a.date), new Date(b.date)) ? -1 : 1))
        setCoachTestingCompletedStatsUser(coachTestingCompletedInfo.sort((a, b) => {
            if (a.completedAt && b.completedAt && a.completedAt !== b.completedAt) {
                return a.completedAt > b.completedAt ? -1 : 1
            }
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        }))

        console.log(submittedInfo, completedInfo)
        setLoading(false)

        setStatsUser(statsInfo.sort((a, b) => isAfter(new Date(a.date), new Date(b.date)) ? -1 : 1))


    }

    const getUserInfo = async (uid) => {
        // console.log('uid', uid)
        setLoading(true)
        const userData = await (await getDoc(doc(db, 'users', uid))).data()
        console.log('userData', userData)
        if (!userData) {
            toast.error('User doesn\'t exist. Taking you to login page.')
            setLoading(false)
            setTimeout(async () => {
                await signOutUser()
                navigate('/login')
            }, 3000)
            return
        }
        setLoading(false)
        dispatch(setUser({ ...userData, id: uid }))
        // fetchUsers()
    }

    const signOutUser = async () => {
        await auth.signOut();
    }

    const fetchUsers = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, `users`))))
        // console.log(docs)
        setReturnedUsers(docs.sort((a, b) => a.firstName.toLowerCase() > b.firstName.toLowerCase() ? 1 : -1))
        fetchLoginMetadata(docs)
        // setReturnedUsers(docs.map(a => !a.created ? { ...a, created: new Date().toISOString() } : a).sort((a, b) => isAfter(new Date(a.created), new Date(b.created)) ? 1 : -1))
    }

    // Sign-in times live in Firebase Auth, not Firestore, so they come from a
    // function rather than the users collection.
    const fetchLoginMetadata = async (users) => {
        const uids = users.map(row => row.id).filter(Boolean)

        if (!uids.length) {
            return
        }

        setLoadingLoginMetadata(true)
        try {
            const token = await auth.currentUser.getIdToken()
            const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/getUserLoginMetadata', { uids, token })

            if (resp.data.err) {
                toast.error(resp.data.err)
                return
            }

            setLoginMetadata(resp.data.data || {})
        } catch (error) {
            console.log('Unable to load login activity', error)
        } finally {
            setLoadingLoginMetadata(false)
        }
    }

    const renderLastLogin = (userId) => {
        const entry = loginMetadata[userId]

        if (!entry) {
            return loadingLoginMetadata ? '...' : '-'
        }

        if (!entry.lastSignInTime) {
            return <span style={{ color: '#c00', fontWeight: '700' }}>Never</span>
        }

        return format(new Date(entry.lastSignInTime), 'dd/MMM/yyyy')
    }

    const scheduledNotificationAudiences = [
        { value: 'parent', label: 'Parents' },
        { value: 'coach', label: 'Coaches' },
        { value: 'center', label: 'Centers' },
    ]

    const getAudienceLabel = (value) => (scheduledNotificationAudiences.find(row => row.value === value) || {}).label || value

    const fetchScheduledNotifications = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'scheduled-notifications'), orderBy('scheduledAt', 'asc'))))
        setScheduledNotifications(docs)
    }

    const resetScheduleNotificationForm = () => {
        setEditingScheduledNotificationId('')
        setScheduleAudience('parent')
        setScheduleTitle('')
        setScheduleBody('')
        setScheduleAt('')
    }

    const openScheduleNotification = (row) => {
        if (row) {
            setEditingScheduledNotificationId(row.id)
            setScheduleAudience(row.type || 'parent')
            setScheduleTitle(row.title || '')
            setScheduleBody(row.body || '')
            // datetime-local inputs take local time with no zone.
            setScheduleAt(row.scheduledAt ? format(new Date(row.scheduledAt), "yyyy-MM-dd'T'HH:mm") : '')
        } else {
            resetScheduleNotificationForm()
        }
        setShowScheduleNotification(true)
    }

    const saveScheduledNotification = async () => {
        const title = scheduleTitle.trim()
        const body = scheduleBody.trim()
        const scheduledDate = scheduleAt ? new Date(scheduleAt) : null

        if (!title) {
            toast.error('A title is required.')
            return
        }
        if (!scheduledDate || isNaN(scheduledDate.getTime())) {
            toast.error('Choose a date and time to send.')
            return
        }
        if (scheduledDate.getTime() <= Date.now()) {
            toast.error('The send time must be in the future.')
            return
        }

        setSavingScheduledNotification(true)
        const nowIso = new Date().toISOString()
        const fields = { type: scheduleAudience, title, body, scheduledAt: scheduledDate.toISOString() }

        try {
            if (editingScheduledNotificationId) {
                const ref = doc(db, 'scheduled-notifications', editingScheduledNotificationId)
                // Guard against editing one the scheduler has already picked up.
                await runTransaction(db, async (transaction) => {
                    const snapshot = await transaction.get(ref)
                    if (!snapshot.exists() || snapshot.data().status !== 'scheduled') {
                        throw new Error('This notification has already been sent or cancelled.')
                    }
                    transaction.update(ref, { ...fields, updatedAt: nowIso, updatedBy: userInfo?.id || '' })
                })
                toast.success('Scheduled notification updated.')
            } else {
                await addDoc(collection(db, 'scheduled-notifications'), {
                    ...fields,
                    status: 'scheduled',
                    created: nowIso,
                    createdBy: userInfo?.id || '',
                    createdByName: `${userInfo?.firstName || ''} ${userInfo?.lastName || ''}`.trim(),
                })
                toast.success('Notification scheduled.')
            }

            setShowScheduleNotification(false)
            resetScheduleNotificationForm()
            fetchScheduledNotifications()
        } catch (error) {
            toast.error(error.message || 'Unable to save scheduled notification.')
            fetchScheduledNotifications()
        } finally {
            setSavingScheduledNotification(false)
        }
    }

    const cancelScheduledNotification = async (row) => {
        if (!window.confirm(`Cancel "${row.title}"? It will not be sent.`)) {
            return
        }

        const ref = doc(db, 'scheduled-notifications', row.id)
        try {
            await runTransaction(db, async (transaction) => {
                const snapshot = await transaction.get(ref)
                if (!snapshot.exists() || snapshot.data().status !== 'scheduled') {
                    throw new Error('This notification has already been sent or cancelled.')
                }
                transaction.update(ref, { status: 'cancelled', cancelledAt: new Date().toISOString(), cancelledBy: userInfo?.id || '' })
            })
            toast.success('Scheduled notification cancelled.')
        } catch (error) {
            toast.error(error.message || 'Unable to cancel scheduled notification.')
        }
        fetchScheduledNotifications()
    }

    const renderScheduledNotificationStatus = ({ status, successCount, recipientCount, error }) => {
        const colors = { scheduled: '#1a73e8', sending: '#e68a00', sent: 'green', cancelled: '#777', failed: 'red' }
        const label = status === 'sent' ? `Sent (${successCount || 0}/${recipientCount || 0})` : (status || '').charAt(0).toUpperCase() + (status || '').slice(1)
        return <span title={error || ''} style={{ color: colors[status] || '#000', fontWeight: 700 }}>{label}</span>
    }

    const fetchInfluencers = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'influencer-codes'), orderBy('created', 'desc'))))
        setInfluencers(docs)
    }

    const handleSortCreated = (docs) => docs.map(a => !a.created ? { ...a, created: new Date('2025/01/01').toISOString() } : a).sort((a, b) => isAfter(new Date(a.created), new Date(b.created)) ? -1 : 1)

    const saveGroup = async () => {

        if (editId) {
            await setDoc(doc(db, 'chat-groups', editId), { groupName, groupIcon, members })
        } else {
            await addDoc(collection(db, 'chat-groups'), { groupName, groupIcon, members })
        }

        setIsAdding(false)
        setEditId('')
        fetchUserGroups()
    }

    const deleteGroup = async () => {

        await deleteDoc(doc(db, 'chat-groups', showDeletePopup))
        setShowDeletePopup(false)
        fetchUserGroups()
    }

    const urlParams = getUrlParams()
    if (urlParams && urlParams.id) {

        const goBack = () => {

            const canGoBack = location.key !== 'default';
            if (canGoBack) {
                navigate(-1)
            } else {
                navigate('/')
            }
        }

        return <div className="container">
            <Header />
            <>
                <button className="textButton" style={{ marginLeft: '0' }} onClick={goBack}> {'←Back'}</button>
                {loading && <div>Loading....</div>}
                {selectedStatsUser && <div style={{ marginBottom: '20px' }}>
                    <h2 style={{ marginBottom: '8px' }}>
                        {selectedStatsUser.firstName || selectedStatsUser.lastName
                            ? `${selectedStatsUser.firstName || ''} ${selectedStatsUser.lastName || ''}`.trim()
                            : (selectedStatsUser.email || selectedStatsUser.id)}
                    </h2>
                    {selectedStatsUser.role === 'parent' && <p style={{ margin: 0, fontSize: '15px', color: '#555' }}>
                        Parent: {`${selectedStatsUser.firstName || ''} ${selectedStatsUser.lastName || ''}`.trim() || '-'}
                        {selectedStatsUser.childName ? ` | Child: ${selectedStatsUser.childName}` : ''}
                    </p>}
                    {selectedStatsUser.role === 'child' && <p style={{ margin: 0, fontSize: '15px', color: '#555' }}>
                        Parent: {selectedStatsUser.parentName || '-'}
                        {selectedStatsUser.childName ? ` | Child: ${selectedStatsUser.childName}` : ''}
                    </p>}
                    {selectedStatsUser.role !== 'parent' && selectedStatsUser.role !== 'child' && <p style={{ margin: 0, fontSize: '15px', color: '#555' }}>
                        Role: {selectedStatsUser.role || '-'}
                        {selectedStatsUser.email ? ` | ${selectedStatsUser.email}` : ''}
                    </p>}
                </div>}
                <h2>Watched Videos</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Date
                            </th>
                            <th>
                                Name
                            </th>
                            <th>
                                Category
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {statsUser.map(r => <tr key={r.id}>
                            <td>{format(new Date(r.date), 'dd MMM yyyy')}</td>
                            <td style={{ marginLeft: 20 }}>{r.name}</td>
                            <td style={{ marginLeft: 20 }}>{r.filter}</td>
                        </tr>)}
                    </tbody>
                </table>


                <h2>Submitted Activities</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Category
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {submittedStatsUser.map(r => <tr key={r.id}>
                            <td style={{ marginLeft: 20 }}>{r.name}</td>
                            <td style={{ marginLeft: 20 }}>{r.filter}</td>
                        </tr>)}
                    </tbody>
                </table>

                <h2>Coach PDF / Overview Views</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Date
                            </th>
                            <th>
                                Tab
                            </th>
                            <th>
                                Category
                            </th>
                            <th>
                                Subcategory
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {coachTabStatsUser.map(r => <tr key={r.id}>
                            <td>{format(new Date(r.date), 'dd MMM yyyy')}</td>
                            <td style={{ marginLeft: 20 }}>{r.tab}</td>
                            <td style={{ marginLeft: 20 }}>{r.categoryName}</td>
                            <td style={{ marginLeft: 20 }}>{r.subCategoryName}</td>
                        </tr>)}
                    </tbody>
                </table>

                <h2>Completed Activities</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Category
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {completedStatsUser.map(r => <tr key={r.id}>
                            <td style={{ marginLeft: 20 }}>{r.name}</td>
                            <td style={{ marginLeft: 20 }}>{r.filter}</td>
                        </tr>)}
                    </tbody>
                </table>

                <h2>Coach Brain Videos Watched</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Date
                            </th>
                            <th>
                                Category
                            </th>
                            <th>
                                Video
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {coachBrainWatchedStatsUser.map(r => <tr key={r.id}>
                            <td>{format(new Date(r.date), 'dd MMM yyyy')}</td>
                            <td style={{ marginLeft: 20 }}>{r.categoryName}</td>
                            <td style={{ marginLeft: 20 }}>{r.activityName}</td>
                        </tr>)}
                    </tbody>
                </table>

                <h2>Coach Testing Completed</h2>
                <table>
                    <thead>
                        <tr>
                            <th>
                                Completed At
                            </th>
                            <th>
                                Video
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {coachTestingCompletedStatsUser.map(r => <tr key={r.id}>
                            <td>{r.completedAt ? format(new Date(r.completedAt), 'dd MMM yyyy') : '-'}</td>
                            <td style={{ marginLeft: 20 }}>{r.name}</td>
                        </tr>)}
                    </tbody>
                </table>

            </>

        </div>
    }

    const headers = ['Time', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']


    const getBookings = (desc, day) => {
        const matchingBookings = bookings.filter(r => r.desc === desc && r.day == day)
        return matchingBookings
    }

    const returnWeekSchedule = (desc) => {

        const hasMatchingSchedule = schedules.find(schedule => parseInt(schedule.startWeekIndex) <= weekOfYear && parseInt(schedule.endWeekIndex) >= weekOfYear)

        if (hasMatchingSchedule) {
            return [
                null,
                null,
                {
                    name: 'Yoga',
                    day: 'Wed',
                    backgroundColor: '#fff601',
                    students: getBookings(desc, 'Wed')
                },
                {
                    name: 'Gymnastics',
                    day: 'Thu',
                    backgroundColor: '#18d904',
                    students: getBookings(desc, 'Thu')
                },
                {
                    name: 'Music',
                    day: 'Fri',
                    backgroundColor: '#ff82e0',
                    students: getBookings(desc, 'Fri')
                },
                {
                    name: 'Sport',
                    day: 'Sat',
                    backgroundColor: '#15bafe',
                    students: getBookings(desc, 'Sat')
                },
                null,
            ]
        }

        return [null, null, null, null, null, null, null]
    }


    const timeblocks = [
        {
            title: '9:30AM',
            desc: '2-3 yo',
            dayIndexes: returnWeekSchedule('2-3 yo'),
            price: 20
        },
        {
            title: '10:15AM',
            desc: '3-4 yo',
            dayIndexes: returnWeekSchedule('3-4 yo'),
            price: 25
        },
        {
            title: '11:15AM',
            desc: '4-6 yo',
            dayIndexes: returnWeekSchedule('4-6 yo'),
            price: 25
        }
    ]


    const sendPushNotification = async () => {
        setLoading(true)

        const notifyType = showNotifyCoaches ? 'coach' : showNotifyCenters ? 'center' : 'parent'
        const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/notifyUsers', { type: notifyType, title: notificationTitle, body: notificationBody },)
        // const resp = await axios.post('http://127.0.0.1:5001/mini-monstars-au/australia-southeast2/notifyUsers', { type: notifyType, title: notificationTitle, body: notificationBody },)

        console.log(resp.data)
        if (resp.data.err) {
            toast.error('Unknown error ocurred. Try again.')
            setLoading(false)
            return
        }


        if (showNotifyCoaches) {
            setShowNotifyCoaches(false)
        } else if (showNotifyCenters) {
            setShowNotifyCenters(false)
        } else {

            setShowNotifyParents(false)
        }

        toast.success('Sent push notifications.')
        setLoading(false)
    }

    const roleOptions = ['admin', 'staff']

    const resetInfluencerForm = () => {
        setInfluencerName('')
        setInfluencerEmail('')
    }

    const createInfluencerCode = async () => {
        if (!influencerName.trim()) {
            toast.error('Influencer name is required.')
            return
        }
        if (!influencerEmail.trim()) {
            toast.error('Influencer email is required.')
            return
        }
        if (checkEmailInValid(influencerEmail)) {
            toast.error('Enter a valid email address.')
            return
        }

        setCreatingInfluencer(true)
        try {
            const trimmedName = influencerName.trim()
            const trimmedEmail = influencerEmail.trim().toLowerCase()
            const token = await auth.currentUser.getIdToken()
            const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/createInfluencerInvite', {
                name: trimmedName,
                email: trimmedEmail,
                token,
            })

            if (resp.data.err) {
                toast.error(resp.data.err)
            } else {
                const createdCode = resp.data?.data?.code || ''
                toast.success(createdCode ? `Influencer code created and email sent: ${createdCode}` : 'Influencer code created and email sent.')
            }

            resetInfluencerForm()
            setShowAddInfluencer(false)
            fetchInfluencers()
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.err || 'Unable to create influencer code.')
        }
        setCreatingInfluencer(false)
    }

    const toggleInfluencerStatus = async (code, isActive) => {
        setTogglingInfluencerCode(code)
        try {
            await setDoc(doc(db, 'influencer-codes', code), {
                isActive: !isActive,
                updated: new Date().toISOString(),
                deactivatedAt: isActive ? new Date().toISOString() : '',
                reactivatedAt: !isActive ? new Date().toISOString() : '',
            }, { merge: true })
            setInfluencers((prev) => prev.map((row) => row.id === code ? {
                ...row,
                isActive: !isActive,
                updated: new Date().toISOString(),
                deactivatedAt: isActive ? new Date().toISOString() : '',
                reactivatedAt: !isActive ? new Date().toISOString() : '',
            } : row))
            toast.success(!isActive ? 'Influencer code reactivated.' : 'Influencer code deactivated.')
        } catch (error) {
            console.error(error)
            toast.error('Unable to update influencer code.')
        }
        setTogglingInfluencerCode('')
    }

    const handleRoleUpdate = async (id, nextRole) => {
        if (!roleOptions.includes(nextRole)) {
            toast.error('Role must be admin or staff.')
            return
        }
        try {
            await setDoc(doc(db, 'users', id), { role: nextRole }, { merge: true })
            setReturnedUsers((prev) => prev.map((user) => (user.id === id ? { ...user, role: nextRole } : user)))
            setEditingUserId('')
            toast.success('Role updated.')
        } catch (error) {
            console.error(error)
            toast.error('Unable to update role.')
        }
    }

    const matchesActiveTab = (user) => {
        if (activeTab === 'All') return true
        if (activeTab === 'Parents') return user.role === 'parent'
        if (activeTab === 'Coaches') return user.role === 'coach'
        if (activeTab === 'Centers') return user.role === 'center'
        if (activeTab === 'Admin') return user.role === 'admin'
        if (activeTab === 'Staff') return user.role === 'staff'
        return true
    }

    const resetAddUserForm = () => {
        setAddFirstName('')
        setAddLastName('')
        setAddEmail('')
        setAddPassword('')
        setAddChildName('')
        setAddRole('staff')
    }

    const createAdminStaffUser = async () => {
        setAddUserLoading(true)
        try {
            const token = await auth.currentUser.getIdToken()
            const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/createAdminStaffUser', {
                firstName: addFirstName,
                lastName: addLastName,
                email: addEmail.trim(),
                password: addPassword,
                childName: addChildName,
                role: addRole,
                token,
            })
            if (resp.data.err) {
                toast.error(resp.data.err)
            } else {
                toast.success('User created.')
                resetAddUserForm()
                setShowAddUser(false)
                fetchUsers()
            }
        } catch (error) {
            console.error(error)
            toast.error('Unable to create user.')
        }
        setAddUserLoading(false)
    }

    const deleteAdminStaffUser = async () => {
        if (!deletingUserId) {
            return
        }

        setDeleteUserLoading(true)
        try {
            const token = await auth.currentUser.getIdToken()
            const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/deleteAdminStaffUser', {
                userId: deletingUserId,
                token,
            })

            if (resp.data.err) {
                toast.error(resp.data.err)
            } else {
                toast.success('User deleted.')
                setReturnedUsers((prev) => prev.filter((user) => user.id !== deletingUserId))
                setDeletingUserId('')
            }
        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.err || 'Unable to delete user.')
        }
        setDeleteUserLoading(false)
    }

    return <div className="container">
        <Header />
        <>

            <Tabs tabs={['Users', 'Groups', 'Bookings', 'Holiday Bookings', 'Influencers', 'Scheduled Notifications']} currentTab={page} setCurrentTab={setPage} />
            {page === 'Users' ? <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h2>Users({returnedUsers.filter(matchesActiveTab).length})</h2>
                    <button className="textButton" onClick={() => setShowNotifyCoaches(true)}>Notify Coaches</button>
                    <button className="textButton" onClick={() => setShowNotifyParents(true)}>Notify Parents</button>
                    <button className="textButton" onClick={() => setShowNotifyCenters(true)}>Notify Centers</button>
                    <div style={{ marginLeft: 'auto', marginRight: '20px', marginTop: '-20px' }}>
                        <Input type={'text'} value={search} placeholder={'Search'} setValue={setSearch} errors={[]} />
                    </div>
                </div>

                <Tabs tabs={['All', 'Coaches', 'Parents', 'Centers', 'Admin', 'Staff']} currentTab={activeTab} setCurrentTab={setActiveTab} />
                <button style={{ margin: '0 10px 10px auto' }} onClick={() => setShowAddUser(true)}>+ Add Admin/Staff</button>

                <ModalComp showModal={!!showNotifyCoaches} setShowModal={setShowNotifyCoaches}>
                    <h2 style={{ textAlign: 'center' }}>Notify Coaches</h2>
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'notificationTitle'} value={notificationTitle} setValue={setNotificationTitle} label={'Notification Title'} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'notificationBody'} value={notificationBody} setValue={setNotificationBody} label={'Notification Body'} />
                    {loading && <p>Please wait, sending to all...</p>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                        <button style={{ width: '200px' }} disabled={!notificationTitle || loading} onClick={sendPushNotification}> Send</button>
                        <button className="textButton" style={{ marginTop: '20px' }} onClick={() => setShowNotifyCoaches(false)}> Cancel</button>
                    </div>
                </ModalComp>

                <ModalComp showModal={!!showNotifyParents} setShowModal={setShowNotifyParents}>
                    <h2 style={{ textAlign: 'center' }}>Notify Parents</h2>
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'notificationTitle'} value={notificationTitle} setValue={setNotificationTitle} label={'Notification Title'} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'notificationBody'} value={notificationBody} setValue={setNotificationBody} label={'Notification Body'} />
                    {loading && <p>Please wait, sending to all...</p>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                        <button style={{ width: '200px' }} disabled={!notificationTitle || loading} onClick={sendPushNotification}> Send</button>
                        <button className="textButton" style={{ marginTop: '20px' }} onClick={() => setShowNotifyParents(false)}> Cancel</button>
                    </div>
                </ModalComp>

                <ModalComp showModal={!!showNotifyCenters} setShowModal={setShowNotifyCenters}>
                    <h2 style={{ textAlign: 'center' }}>Notify Centers</h2>
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'notificationTitle'} value={notificationTitle} setValue={setNotificationTitle} label={'Notification Title'} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'notificationBody'} value={notificationBody} setValue={setNotificationBody} label={'Notification Body'} />
                    {loading && <p>Please wait, sending to all...</p>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                        <button style={{ width: '200px' }} disabled={!notificationTitle || loading} onClick={sendPushNotification}> Send</button>
                        <button className="textButton" style={{ marginTop: '20px' }} onClick={() => setShowNotifyCenters(false)}> Cancel</button>
                    </div>
                </ModalComp>

                <ModalComp showModal={!!showAddUser} setShowModal={setShowAddUser}>
                    <h2 style={{ textAlign: 'center' }}>Add Admin/Staff</h2>
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'addFirstName'} value={addFirstName} setValue={setAddFirstName} label={'First Name'} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'addLastName'} value={addLastName} setValue={setAddLastName} label={'Last Name'} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'addEmail'} value={addEmail} setValue={setAddEmail} label={'Email'} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'addPassword'} value={addPassword} setValue={setAddPassword} label={'Password (You can change) - Min 6 characters'} />
                    <span style={{ color: 'red' }}>Save this password! Not shown again.</span>
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'addChildName'} value={addChildName} setValue={setAddChildName} label={'Child Name'} />
                    <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Role</label>
                    <select className="role-select" value={addRole} onChange={(event) => setAddRole(event.target.value)}>
                        {roleOptions.map((option) => (
                            <option key={option} value={option}>{option}</option>
                        ))}
                    </select>
                    {addUserLoading && <p>Please wait, creating user...</p>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                        <button
                            style={{ width: '200px' }}
                            disabled={!addFirstName || !addLastName || !addEmail || !addEmail.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/) || !addPassword || !addChildName || addUserLoading}
                            onClick={createAdminStaffUser}
                        >
                            Save
                        </button>
                        <button
                            className="textButton"
                            style={{ marginTop: '20px' }}
                            onClick={() => { setShowAddUser(false); resetAddUserForm() }}
                        >
                            Cancel
                        </button>
                    </div>
                </ModalComp>

                <ModalComp showModal={!!deletingUserId} setShowModal={() => { if (!deleteUserLoading) { setDeletingUserId('') } }}>
                    <h2 style={{ textAlign: 'center' }}>Delete User</h2>
                    <p style={{ textAlign: 'center' }}>This wipes the app account from our side, removes Firebase Auth access, deletes the Firestore user record, archives linked compliance records, and removes the user from chat groups. Existing historical records that already store names/text may remain.</p>
                    {deleteUserLoading && <p>Please wait, deleting user...</p>}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                        <button style={{ width: '200px', backgroundColor: 'red' }} disabled={deleteUserLoading} onClick={deleteAdminStaffUser}>Delete</button>
                        <button className="textButton" style={{ marginTop: '20px' }} disabled={deleteUserLoading} onClick={() => setDeletingUserId('')}>Cancel</button>
                    </div>
                </ModalComp>

                <table>
                    <thead>
                        <tr>
                            <th>
                                Name
                            </th>
                            <th>
                                Email
                            </th>
                            <th>
                                Role
                            </th>
                            <th>
                                Child Participate / Center Name
                            </th>
                            <th>
                                Children
                            </th>
                            <th>
                                Action
                            </th>
                            <th>
                                Last Login
                            </th>
                            <th onClick={() => setReturnedUsers(handleSortCreated([...returnedUsers]))}>
                                Created
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {returnedUsers.filter(matchesActiveTab).filter(a => search ? (a.firstName.toLowerCase().includes(search.toLowerCase()) || a.lastName.toLowerCase().includes(search.toLowerCase())) || a.email.toLowerCase().includes(search.toLowerCase()) : true).map(({ id, firstName, lastName, email, childParticipate, centerName, role, children, created, startDate }) => <tr key={id}>
                            <td>
                                {firstName} {lastName}
                            </td>
                            <td>
                                {email}
                            </td>
                            <td>
                                {editingUserId === id ? (
                                    <select className="role-select" value={editingRole} onChange={(event) => setEditingRole(event.target.value)}>
                                        {roleOptions.map((option) => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                ) : role}
                            </td>
                            <td>
                                {childParticipate || 'No'} / {centerName || ''}
                            </td>
                            <td>
                                {children.map(({ name, id }) => <a className="hover" style={{ color: 'blue', marginLeft: 10 }} onClick={() => navigate(`/users?id=${id}`)}>{name}</a>)}
                            </td>
                            <td>
                                {roleOptions.includes(role) ? (
                                    editingUserId === id ? (
                                        <>
                                            <button className="textButton" onClick={() => handleRoleUpdate(id, editingRole)}>Save</button>
                                            <button className="textButton" onClick={() => setEditingUserId('')}>Cancel</button>
                                        </>
                                    ) : (
                                        <>
                                            <button className="textButton" onClick={() => { setEditingUserId(id); setEditingRole(role) }}>Edit</button>
                                        </>
                                    )
                                ) : ''}
                                {userInfo && userInfo.id !== id && <button className="textButton" style={{ color: 'red' }} onClick={() => setDeletingUserId(id)}>Delete</button>}
                            </td>
                            <td>
                                {renderLastLogin(id)}
                            </td>
                            <td>
                                {created ? format(new Date(created), 'dd/MMM/yyyy') : ''}
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </> : page === 'Groups' ? <>

                <button className="textButton" style={{ marginLeft: 'auto' }} onClick={() => { setIsAdding(true); setEditId('') }}>+ Add New</button>
                {isAdding ? <>
                    <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000', }}>Group Icon</label>
                    <MyDropzone storageLocation={`Activities/${randomString()}`} customMessage={'Drop file here to upload'} editing={true} errors={[]} name={'thumbnail'} image={groupIcon} updateImage={(doc) => setGroupIcon(doc)} />
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'groupName'} value={groupName} setValue={setGroupName} label={'Group Name'} />
                    <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Members</label>
                    {returnedUsers.filter(r => (r.role === 'coach' && r.status === 'Active') || r.id === 'ZIxzqin7VAVgTFkEWGRlgosFcdq2').map(r =>
                        <div key={r.id} style={{ marginTop: '5px' }}>
                            <Checkbox errors={[]} label={r.firstName + ' ' + r.lastName} value={members.includes(r.id)} setValue={() => { members.includes(r.id) ? setMembers([...members.filter(x => x !== r.id)]) : setMembers([...members, r.id]) }} />
                        </div>
                    )}

                    <div style={{ width: '200px', margin: '10px auto', display: 'flex', flexDirection: 'column' }}>
                        <button disabled={!groupName || members.length === 0} onClick={saveGroup}>Save</button>
                        <button style={{ margin: '20px auto' }} className="textButton" onClick={() => { setIsAdding(false); setEditId('') }}>Cancel</button>
                    </div>
                </> :
                    <>


                        <ModalComp showModal={!!showDeletePopup} setShowModal={setShowDeletePopup}>
                            <h2 style={{ textAlign: 'center' }}>Delete Group</h2>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                                <button style={{ width: '200px' }} onClick={deleteGroup}> Delete</button>
                                <button className="textButton" style={{ marginTop: '20px' }} onClick={() => setShowDeletePopup(false)}> Cancel</button>
                            </div>
                        </ModalComp>

                        <h2>Groups({groups.length})</h2>

                        <table>
                            <thead>
                                <tr>
                                    {/* <th>
                                        Image
                                    </th> */}
                                    <th>
                                        Name
                                    </th>
                                    <th>
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {groups.map(({ id, groupName, groupIcon, members }) => <tr key={id}>
                                    {/* <td onClick={() => { setGroupName(groupName); setMembers(members); setEditId(id); setIsAdding(true) }}>
                                        {groupIcon && <img src={groupIcon} />}
                                    </td> */}
                                    <td onClick={() => { setGroupName(groupName); setMembers(members); setEditId(id); setGroupIcon(groupIcon); setIsAdding(true) }}>
                                        {groupName}
                                    </td>
                                    <td>
                                        <button className="textButton" onClick={() => { setShowDeletePopup(id) }}>{'Delete'}</button>
                                    </td>

                                </tr>)}
                            </tbody>
                        </table>
                    </>}
            </> : page === 'Bookings' ? <>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: 'auto' }}>
                    <b style={{ color: '#FF7100', fontSize: '21px' }} onClick={() => setCurrentDate(subDays(currentDate, 7))}>{'<'}</b>
                    <p>Week Starting: {format(currentDate, 'dd MMM yyyy')}</p>
                    <b style={{ color: '#FF7100', fontSize: '21px' }} onClick={() => setCurrentDate(addDays(currentDate, 7))}>{'>'}</b>
                </div>

                <ModalComp showModal={!!showBookingDetails} setShowModal={setShowBookingDetails}>

                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                        <p>{showBookingDetails.name} {showBookingDetails.desc} {showBookingDetails.title}</p>
                        <table>
                            <thead>
                                <th>Class Type</th>
                                <th>Parent Name</th>
                                <th>Phone Number</th>
                                <th>Child Name</th>
                                <th>Uniform</th>
                                <th>Email</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Postcode</th>
                                <th>Price</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{showBookingDetails.isTrial ? 'Trial' : showBookingDetails.isSingleClass ? 'Single' : 'Term'}</td>
                                    <td>{showBookingDetails.parentName}</td>
                                    <td>{showBookingDetails.phoneNumber}</td>
                                    <td>{showBookingDetails.childName}</td>
                                    <td>{showBookingDetails.shirtSize ? `Shirt: ${showBookingDetails.shirtSize} , Short ${showBookingDetails.shortSize}` : '-'}</td>
                                    <td>{showBookingDetails.email}</td>
                                    <td>{showBookingDetails.startDateString}</td>
                                    <td>{showBookingDetails.endDateString}</td>
                                    <td>{showBookingDetails.postcode}</td>
                                    <td>${showBookingDetails.totalPrice}</td>
                                </tr>
                            </tbody>
                        </table>
                        <button style={{ width: '200px' }} onClick={() => { setShowBookingDetails(false) }}> Close</button>
                    </div>
                </ModalComp>
                <table style={{ width: '1216px', margin: 'auto' }}>
                    <thead>
                        <tr>
                            {headers.map(header => <th key={header} style={{ backgroundColor: 'red' }}>
                                {header.toUpperCase()}
                            </th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {timeblocks.map(row => <tr key={row.title}>
                            <td style={{ backgroundColor: 'red' }}>
                                <b style={{ margin: 0 }}>{row.title}</b>
                                <p style={{ margin: 0 }}>{row.desc}</p>
                            </td>
                            {row.dayIndexes.map((day, index) => <td key={row.title + index} style={{ textTransform: 'uppercase', backgroundColor: day ? day.backgroundColor : 'white' }}>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <p style={{ margin: 0, color: 'grey' }}>{day ? day.disabled ? 'Booked out!' : day.name : ''}</p>
                                    {day && day.students.length > 0 ? day.students.map(r => <p style={{ margin: 0, marginBottom: '10px', color: 'black' }} onClick={() => { setShowBookingDetails(r) }}>{r.childName} <span style={{ color: '#DCDCDC' }}>{r.isTrial ? 'Trial' : r.isSingleClass ? 'Single' : 'Term'}</span></p>) : ''}
                                </div>
                            </td>)}
                        </tr>)}
                    </tbody>
                </table>

                <h2>Booking Interests</h2>
                <table>
                    <thead>
                        <th>Date Interested</th>
                        <th>Age/Time</th>
                        <th>Activity</th>
                        <th>Day</th>
                        <th>Email</th>
                        <th>Parent Name</th>
                        <th>Phone Number</th>
                        <th>Post Code</th>
                    </thead>
                    <tbody>
                        {bookingInterests.map(interest => <tr key={interest.id}>
                            <td>{interest.currentDate}</td>
                            <td>{interest.age} {interest.time}</td>
                            <td>{interest.activity}</td>
                            <td>{interest.day}</td>
                            <td>{interest.email}</td>
                            <td>{interest.parentName}</td>
                            <td>{interest.phoneNumber}</td>
                            <td>{interest.postcode}</td>
                        </tr>)}
                    </tbody>
                </table>



                <h2>Bookings</h2>
                <table>
                    <thead>
                        <th>Created Date</th>
                        <th>Child Name</th>
                        <th>Type</th>
                        <th>From Week - Till Week</th>
                        <th>Email</th>
                        <th>Parent Name</th>
                        <th>Phone Number</th>
                        <th>Post Code</th>
                    </thead>
                    <tbody>
                        {allBookings.map(booking => <tr key={booking.id}>
                            <td>{format(new Date(booking.created), 'dd MMM yyyy')}</td>
                            <td>{booking.childName}</td>
                            <td>{booking.isTrial ? 'Trial' : booking.isSingleClass ? 'Single' : 'Term'}</td>
                            <td>{booking.startDateString} - {booking.endDateString}</td>
                            <td>{booking.email}</td>
                            <td>{booking.parentName}</td>
                            <td>{booking.phoneNumber}</td>
                            <td>{booking.postcode}</td>
                        </tr>)}
                    </tbody>
                </table>



            </> : page === 'Holiday Bookings' ? <>
                <table>
                    <thead>
                        <th>Class Type</th>
                        <th>Parent Name</th>
                        <th>Phone Number</th>
                        <th>Child Name</th>
                        <th>Email</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Postcode</th>
                        <th>Price</th>
                    </thead>
                    <tbody>
                        {allHolidayBookings.map(holidayBooking => <tr key={holidayBooking.id}>
                            <td>{holidayBooking.name}</td>
                            <td>{holidayBooking.parentName}</td>
                            <td>{holidayBooking.phoneNumber}</td>
                            <td>{holidayBooking.childName}</td>
                            <td>{holidayBooking.email}</td>
                            <td>{holidayBooking.desc}</td>
                            <td>{holidayBooking.title}<br /> {holidayBooking.timeBlock}</td>
                            <td>{holidayBooking.postcode}</td>
                            <td>${holidayBooking.price}</td>
                        </tr>)}
                    </tbody>
                </table>
            </> : page === 'Influencers' ? <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h2>Influencers ({influencers.length})</h2>
                    <button style={{ margin: '0 0 10px auto' }} onClick={() => setShowAddInfluencer(true)}>+ Add Influencer</button>
                </div>

                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Coupon Code</th>
                            <th>Used By</th>
                            <th>Status</th>
                            <th>Created</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {influencers.map(({ id, name, email, code, isActive, created, assignedUserEmail, assignedUserName }) => <tr key={id}>
                            <td>{name || ''}</td>
                            <td>{email || ''}</td>
                            <td style={{ fontWeight: 700, letterSpacing: '1px' }}>{code || id}</td>
                            <td>{assignedUserName || assignedUserEmail || '-'}</td>
                            <td>{isActive === false ? 'Inactive' : 'Active'}</td>
                            <td>{created ? format(new Date(created), 'dd/MMM/yyyy') : ''}</td>
                            <td>
                                <button
                                    className="textButton"
                                    disabled={togglingInfluencerCode === id}
                                    style={{ color: isActive === false ? 'green' : 'red' }}
                                    onClick={() => toggleInfluencerStatus(id, isActive !== false)}
                                >
                                    {togglingInfluencerCode === id ? 'Saving...' : isActive === false ? 'Reactivate' : 'Deactivate'}
                                </button>
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            </> : page === 'Scheduled Notifications' ? <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <h2>Scheduled Notifications</h2>
                    <button style={{ margin: '0 0 10px auto' }} onClick={() => openScheduleNotification()}>+ Schedule Notification</button>
                </div>

                <Tabs tabs={['Upcoming', 'History']} currentTab={scheduledNotificationsTab} setCurrentTab={setScheduledNotificationsTab} />

                {(() => {
                    const upcoming = scheduledNotificationsTab === 'Upcoming'
                    const rows = scheduledNotifications
                        .filter(row => upcoming ? ['scheduled', 'sending'].includes(row.status) : !['scheduled', 'sending'].includes(row.status))
                        .sort((a, b) => upcoming ? (a.scheduledAt || '').localeCompare(b.scheduledAt || '') : (b.scheduledAt || '').localeCompare(a.scheduledAt || ''))

                    if (!rows.length) {
                        return <p>{upcoming ? 'Nothing scheduled.' : 'No sent or cancelled notifications yet.'}</p>
                    }

                    return <table>
                        <thead>
                            <tr>
                                <th>Send At</th>
                                <th>Audience</th>
                                <th>Title</th>
                                <th>Body</th>
                                <th>Status</th>
                                <th>Created By</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map(row => <tr key={row.id}>
                                <td style={{ whiteSpace: 'nowrap' }}>{row.scheduledAt ? format(new Date(row.scheduledAt), 'dd/MMM/yyyy h:mm a') : ''}</td>
                                <td>{getAudienceLabel(row.type)}</td>
                                <td>{row.title}</td>
                                <td>{row.body}</td>
                                <td>{renderScheduledNotificationStatus(row)}</td>
                                <td>{row.createdByName || ''}</td>
                                <td style={{ whiteSpace: 'nowrap' }}>
                                    {row.status === 'scheduled' ? <>
                                        <button className="textButton" onClick={() => openScheduleNotification(row)}>Edit</button>
                                        <button className="textButton" style={{ color: 'red' }} onClick={() => cancelScheduledNotification(row)}>Cancel</button>
                                    </> : '-'}
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                })()}
            </> : null}

            <ModalComp showModal={!!showAddInfluencer} setShowModal={(value) => {
                setShowAddInfluencer(value)
                if (!value) {
                    resetInfluencerForm()
                }
            }}>
                <h2 style={{ textAlign: 'center' }}>Add Influencer</h2>
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'influencerName'} value={influencerName} setValue={setInfluencerName} label={'Name'} />
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'influencerEmail'} value={influencerEmail} setValue={setInfluencerEmail} label={'Email'} />
                {creatingInfluencer && <p>Please wait, creating influencer code...</p>}
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                    <button style={{ width: '200px' }} disabled={!influencerName.trim() || !influencerEmail.trim() || creatingInfluencer} onClick={createInfluencerCode}>
                        {creatingInfluencer ? 'Creating...' : 'Create Code'}
                    </button>
                    <button
                        className="textButton"
                        style={{ marginTop: '20px' }}
                        onClick={() => {
                            setShowAddInfluencer(false)
                            resetInfluencerForm()
                        }}
                    >
                        Cancel
                    </button>
                </div>
            </ModalComp>

            <ModalComp showModal={!!showScheduleNotification} setShowModal={(value) => {
                setShowScheduleNotification(value)
                if (!value) {
                    resetScheduleNotificationForm()
                }
            }}>
                <h2 style={{ textAlign: 'center' }}>{editingScheduledNotificationId ? 'Edit Scheduled Notification' : 'Schedule Notification'}</h2>
                <label style={{ display: 'flex', marginTop: '25px', fontWeight: '800', fontSize: '14px', color: '#000' }}>Send To</label>
                <select value={scheduleAudience} onChange={(event) => setScheduleAudience(event.target.value)}>
                    {scheduledNotificationAudiences.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'scheduleTitle'} value={scheduleTitle} setValue={setScheduleTitle} label={'Notification Title'} />
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'scheduleBody'} value={scheduleBody} setValue={setScheduleBody} label={'Notification Body'} />
                <Input bold type={'datetime-local'} errorMessage={''} errors={[]} name={'scheduleAt'} value={scheduleAt} setValue={setScheduleAt} label={'Send At (your local time)'} />
                <p style={{ fontSize: '12px', color: '#666' }}>Goes out within about a minute of the chosen time.</p>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'center' }}>
                    <button style={{ width: '200px' }} disabled={!scheduleTitle.trim() || !scheduleAt || savingScheduledNotification} onClick={saveScheduledNotification}>
                        {savingScheduledNotification ? 'Saving...' : editingScheduledNotificationId ? 'Save Changes' : 'Schedule'}
                    </button>
                    <button
                        className="textButton"
                        style={{ marginTop: '20px' }}
                        onClick={() => {
                            setShowScheduleNotification(false)
                            resetScheduleNotificationForm()
                        }}
                    >
                        Close
                    </button>
                </div>
            </ModalComp>

        </>
    </div >
}

export default Users
